/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { withServerData, useConfig } from '@xingternal/hops';

import { injectIntl } from 'react-intl';
import LoggedoutView from '@xingternal/xing-view/LoggedoutView';
import { TopBar } from '@xingternal/top-bar';

import Grid from '@xingternal/xing-grid';
import XingView from '@xingternal/xing-view';

import GlobalStyles from '@xingternal/global-styles';

import withApolloData from '@xingternal/xing-frame-provider/withApolloData';
import { XingFrameProvider } from '@xingternal/xing-frame-provider';

import withStaticData from '@xingternal/xing-frame-provider/withStaticData';
import navigationData from '@xingternal/xing-frame-provider/data/navigation';
import useFeatures from './features/useFeatures';

const LoggedInFrameProvider = withApolloData(XingFrameProvider);
const LoggedOutFrameProvider = withStaticData({ navigationData })(XingFrameProvider);

const Frame = ({
  intl: { formatMessage },
  children,
  disableBanner,
  serverData: { authenticated },
}) => {
  useFeatures();
  const { externalUrl, loginUrl } = useConfig();

  const FrameProvider = authenticated ? LoggedInFrameProvider : LoggedOutFrameProvider;

  if (authenticated) {
    return (
      <FrameProvider userConsentSettings={{ disableBanner }}>
        <GlobalStyles>
          <XingView>
            <TopBar type="header" title={formatMessage({ id: 'CONTACT_FORM_TITLE' })} />
            <Grid type="standard">{children}</Grid>
          </XingView>
        </GlobalStyles>
      </FrameProvider>
    );
  }
  return (
    <FrameProvider userConsentSettings={{ disableBanner }}>
      <GlobalStyles>
        <LoggedoutView homeLink={externalUrl} loginLink={loginUrl}>
          <Grid type="wide">{children}</Grid>
        </LoggedoutView>
      </GlobalStyles>
    </FrameProvider>
  );
};

Frame.propTypes = {
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    formatMessage: PropTypes.func,
  }).isRequired,
  children: PropTypes.element.isRequired,
  disableBanner: PropTypes.bool.isRequired,
  serverData: PropTypes.shape({
    authenticated: PropTypes.bool.isRequired,
  }).isRequired,
};

export default withServerData(injectIntl(Frame));
